export default __webpack_public_path__ + "static/media/kit_10.125176f4.png";